import React from 'react';
import { motion } from "framer-motion";
import { Scale } from "lucide-react";

const TermOfServices = () => {
  return (
    <div className="pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700/50 mb-8">
            <Scale className="w-4 h-4 text-violet-400" />
            <span className="text-sm text-slate-400">Effective Date: March 2026</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Terms of <span className="gradient-text">Service</span>
          </h1>
          <p className="text-lg text-slate-400">
            The rules and guidelines for using Luxkgate.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="prose prose-invert prose-slate max-w-none space-y-8"
        >
          <section className="bg-slate-900/50 border border-slate-800/50 rounded-2xl p-8 md:p-12 text-slate-300">
            <h2 className="text-2xl font-bold text-white mb-4">1. Agreement to Terms</h2>
            <p className="mb-6 leading-relaxed">
              These Terms of Service ("Terms") constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and Luxkgate ("we," "us" or "our"), concerning your access to and use of our payment gateway infrastructure and API services.
            </p>
            <p className="mb-6 leading-relaxed">
              By accessing our services, you agree that you have read, understood, and agree to be bound by all of these Terms of Service. If you do not agree with all of these terms, then you are expressly prohibited from using the site and our payment services and you must discontinue use immediately.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-12">2. User Accounts</h2>
            <p className="mb-6 leading-relaxed">
              When creating an account on our platform (as an Engine, Reseller, or Merchant), you agree to provide accurate, current, and complete information during the registration process.
            </p>
            <ul className="list-disc pl-6 space-y-3 mb-6 opacity-90">
              <li>You are strictly responsible for safeguarding the password and API keys that you use to access the service.</li>
              <li>You agree not to disclose your password or API keys to any unauthorized third party.</li>
              <li>You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-12">3. Payment Processing & Fees</h2>
            <p className="mb-4 leading-relaxed">
              By utilizing our API to process payments, you agree to the following terms regarding transaction settlements and fees:
            </p>
            <ul className="list-disc pl-6 space-y-3 mb-6 opacity-90">
              <li><strong>Fees:</strong> All fees are outlined in your specific contract tier. We reserve the right to modify our pricing structure with a 30-day notice.</li>
              <li><strong>Reserves:</strong> We reserve the right to place a rolling reserve on your merchant account to offset potential chargebacks, fraud, or refunds, depending on your risk profile.</li>
              <li><strong>Compliance:</strong> You must maintain strict compliance with PCI-DSS standards when transmitting credit card data to our endpoints.</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-12">4. Prohibited Activities</h2>
            <p className="mb-6 leading-relaxed">
              You may not access or use the platform for any purpose other than that for which we make the services available. Prohibited activities include, but are not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-3 mb-6 opacity-90">
              <li>Processing transactions for illegal goods, illicit material, or highly-regulated products without explicit written authorization from our compliance team.</li>
              <li>Bypassing, dodging, or in any way circumventing our automated fraud-detection engines and transaction velocity limits.</li>
              <li>Attempting to decipher, decompile, disassemble, or reverse engineer any of the software comprising the Luxkgate API.</li>
            </ul>

            <h2 className="text-2xl font-bold text-white mb-4 mt-12">5. Limitations of Liability</h2>
            <p className="mb-6 leading-relaxed">
              In no event will we or our directors, employees, or processor partners be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, loss of data, or other damages arising from your use of the site or our payment gateways.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4 mt-12">6. Contact Information</h2>
            <p className="leading-relaxed">
              In order to resolve a complaint regarding the Site or to receive further information regarding use of our services, please contact us at: <br />
              <a href="mailto:legal@luxkgate.com" className="text-violet-400 hover:text-violet-300 transition-colors">legal@luxkgate.com</a>
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default TermOfServices;